export default {
  recommendationPerson: '推荐人',
  noPermissionToDownload: '您暂无权限，不可下载',
  batchOperation: '批量操作',
  batchFileDownload: '文件批量下载',
  onlineResume: '在线简历',
  attachmentResume: '附件简历',
  dropApplyPosition: '投递岗位',
  applyJob: '投递职位',
  residenceCardExpired: {
    title: '在留卡已过期',
    content: '在留卡的有效期限已过期，是否继续投递？',
  },
  residenceCardExpiring: {
    title: '在留卡即将过期',
    content: '距在留卡有效期限不足1个月，是否继续投递？',
  },
  job: '职位',
  recommendationReason: '推荐理由',
  apply: '投递',
  cancel: '取消',
  pleaseSelectJob: '请选择职位',
  pleaseSelectEnterprise: '请选择应聘企业',
  pleaseSelectResponsiblePerson: '请选择负责人',
  pleaseSelectJoinDate: '请选择入职日期',
  pleaseEnterReason: '请输入推荐理由',
  delete: '删除',
  fileDownload: '文件下载',
  allMaterials: '全部资料',
  applySuccess: '投递成功',
  applyConfirmTitle: '投递确认',
  appliedCompanyCount: '应聘企业个数',
  applyEnterprise: '应聘企业',
  jobStoppedOpen: '职位已停止开放',
  markAllReadTitle: '全部标为已读',
  markAllReadContent: '确认将全部消息标为已读吗？',
  noMoreMessages: '没有更多信息了~',
  noMessages: '暂无消息',
  summaryInfo: '候选人信息摘要',
  selectionDetail: '选考详情',
  jobDetail: '职位详情',
  applyPosition: '应聘职位',
  jobId: '职位 ID',
  status: '状态',
  status1: '状态',
  selectionProgress: '选考进度',
  applyDate: '应聘时间',
  updateTime: '状态更新时间',
  applyJobPosition: '应聘职位',
  applyJobPositionPlaceholder: '请输入求人ID/求人名',
  responsiblePerson: '负责人',
  /** 候选人本身的负责人，区别于选考维度的「负责人」 */
  candidateOwner: '候选人负责人',
  interviewId: '选考 ID',
  aiScore: 'AI 评分',
  tabResumeScreening: '简历筛选',
  tabInterview: '面试',
  tabOffer: '内定',
  tabOnboarding: '入职',
  tabPendingOnboarding: '待入职',
  tabJoined: '已入职',
  tabTerminated: '已终止',
  joinDate: '入职日期',
  joinDate1: '入职日期',
  interviewInfo: '面试信息',
  terminationReason: '终止原因',
  remark: '备注',
  remarkInfo: '备注信息',
  editRemark: '编辑备注',
  editMessage: '编辑留言',
  interviewSchedule1: '面试日程',
  outerMessage: '外部联络',
  weekShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  stage: '阶段',
  interviewer: '面试官',
  updateScreeningResult: '确认筛选结果',
  changeResponsiblePerson: '变更负责人',
  terminateSelection: '终止选考流程',
  terminateSelection2: '终止选考',
  confirmTerminateSelection: '确认终止选考流程',
  terminateSelectionConfirmMessage: '终止后不可恢复,确认终止选考流程「{interviewId}」?',
  terminate: '终止',
  terminationReasonActiveExit: '主动退出',
  terminationReasonOther: '其他',
  updateInterviewResult: '确认面试结果',
  scheduleInterview: '预约面试',
  interviewWaitConfirm: '确定面试日程',
  scheduleInterview1: '预约面试',
  scheduleInterviewTitle: '预约面试（{stepName}）',
  reScheduleInterview: '重新预约',
  reScheduleInterview1: '重新预约',
  interviewConfirmed1: '面试确定',
  reScheduleInterview2: '重新预约',
  adjustInterview: '调整面试',
  adjustInterviewTitle: '调整面试（{stepName}）',
  interviewInfoTitle: '面试信息（{stepName}）',
  cancelInterview: '取消面试',
  sendJobOffer: '发送内定通知书',
  editSendJobOffer: '修改内定通知书',
  updateOfferResult: '确认内定接受结果',
  confirmJoinDate: '确认入职日期',
  updateJoinDate: '修改入职日期',
  changeJoinDate: '变更',
  confirmJoin: '确认入职',
  confirmJoin1: '确认入职',
  isJoined: '是否入职',
  downloadOnlineResume: '下载在线简历',
  downloadAttachmentResume: '下载附件简历',
  downloadAllMaterials: '下载全部资料',
  interviewSchedule: '面试日程',
  interviewEvaluation: '面试评价',
  internalMessage: '内部留言',
  onlineInterview: '线上面试',
  offlineInterview: '线下面试',
  screeningResult: '筛选结果',
  resumeScreeningResult: '简历筛选结果',
  resumeScreeningResult1: '确认简历筛选结果',
  editResumeScreeningResult1: '更新简历筛选结果',
  interviewResult: '面试结果',
  interviewResultTitle: '确认面试结果（{name}）',
  editInterviewResultTitle: '更新面试结果（{name}）',
  offerResult: '内定结果',
  offerResultBtn2: '内定通知',
  offerResult1: '内定接受结果确认',
  editOfferResult1: '更新内定接受结果',
  waitOfferResult: '内定承諾の結果待ち',
  accept: '接受',
  reject: '拒绝',
  candidateCommunication: '候选人沟通',
  pendingAccept: '待接受',
  expired: '已过期',
  rejected: '待调整',
  pendingScheduleTag: '调整中',
  pendingInterviewTag: '待面试',
  resultPendingTag: '待结果',
  pendingInterviewInvitation: '待接受面试邀请',
  rejectedInterviewInvitation: '面试待调整',
  expiredInterviewInvitation: '面试邀请已过期',
  interviewAcceptedTip: '面试邀请已接受,面试方式及面试时间不支持修改。如需修改,请取消后重新预约。',
  inputMessage: '输入消息',
  uploadAttachment: '上传附件',
  sendMessage: '留言',
  confirmDeleteMessage: '确认删除留言吗？',
  pleaseEnterMessageOrUpload: '请输入留言内容或上传附件',
  pleaseEnterContent: '请输入内容',
  sendSuccess: '发送成功',
  sendFailed: '发送失败，请重试',
  outerMessageNewMessagePrefix: '新消息：',
  outerMessageLabel: '消息：',
  markAsUnread: '标记未读',
  outerMessageRead: '已读',
  outerMessageUnread: '未读',
  showFullText: '查看全文',
  collapseFullText: '收起全文',
  invitationLink: '邀请链接',
  optionalTimeSlots: '可选面试时段',
  interviewTime: '面试时长',
  interviewLink: '面试链接',
  interviewAddress: '面试地址',
  copyInvitationLink: '复制邀请链接',
  lastEditor: '最近编辑人',
  lastEditTime: '最近编辑时间',
  invitationLinkCopied: '邀请链接已复制到剪贴板',
  copyFailed: '复制失败，请手动复制',
  confirmCancelInterview: '确认取消面试',
  confirmCancelInterviewContent: '确认取消候选人「{candidateName}」的面试日程（{stepName}）吗？',
  cancelInterviewSuccess: '取消面试成功',
  cancelInterviewFailed: '取消面试失败',
  expectedJoinDate: '预计 {joinAt} 入职',
  pendingJoin: '待入职',
  joined: '已入职',
  additionalNote: '补充说明',
  comment: '评价',
  pleaseEnterComment: '请输入评价',
  commentPlaceholder: '请填写合格 / 不合格的理由',
  result: '结果',
  notJoined: '未入职',
  joinAtLabel: '入职日',
  actualJoinDate: '入职日：{joinAt}',
  offerLetter: '内定通知书',
  offerLetterTips: '文件格式仅限 pdf，单个文件大小不超过 10MB。',
  pleaseUploadOfferLetter: '请上传内定通知书',
    detail: {
    selectionProgress: '选考进度',
    remark: '备注',
  },
  detailLabel: {
    nameHalfWidthUpperSpace: '（半角英文字母，需大写，以空格分隔）',
    halfWidth: '（半角英文字母、数字及符号）',
    passportNumberHalfWidth: '（半角英数字，需大写）',
    fullWidthCharacters: '（全角文字）',
    halfWidthNumbers: '（半角数字）',
  },
  hovertip: {
    name: '请按照护照的身份事项页面上的要求输入',
  },
  interviewDetail: '面接详情',
}

